/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Category} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  category: Category
}

const CategoryInfoCell: FC<Props> = ({category}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(category.id)
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {category.name}
        </a>
      </div>
    </div>
  )
}

export {CategoryInfoCell}
